interface ChoiceOption {
  value: string;
  label: string;
}

interface ChoicePillsProps {
  label: string;
  controlId: string;
  options: readonly ChoiceOption[];
  value: string | readonly string[];
  multiple?: boolean;
  onChange: (value: string | string[]) => void;
}

export function ChoicePills({
  label,
  controlId,
  options,
  value,
  multiple = false,
  onChange,
}: ChoicePillsProps) {
  const selected = new Set(Array.isArray(value) ? value : value ? [value] : []);
  return (
    <fieldset className="min-w-0">
      <legend className="mb-3 text-sm font-medium text-foreground">{label}</legend>
      <div className="flex flex-wrap gap-2" role={multiple ? "group" : "radiogroup"} aria-label={label}>
        {options.map((option) => {
          const isSelected = selected.has(option.value);
          return (
            <button
              aria-checked={isSelected}
              className={`min-h-10 rounded-full border px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30 ${
                isSelected
                  ? "border-primary bg-primary text-primary-foreground"
                  : "border-border bg-background text-foreground hover:bg-muted"
              }`}
              data-control-id={`${controlId}.${option.value}`}
              key={option.value}
              onClick={() => {
                if (!multiple) {
                  onChange(option.value);
                  return;
                }
                const next = new Set(selected);
                if (next.has(option.value)) next.delete(option.value);
                else next.add(option.value);
                onChange([...next]);
              }}
              role={multiple ? "checkbox" : "radio"}
              type="button"
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
